function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m41.8 84c0.1 0.2 0.1 0.3 0.1 0.5 0 3.3 0.2 6.7 0.5 10 2.6-0.1 4.9-0.1 7.2-0.2h1c-0.3-5-0.4-10-0.5-15-1.7 1.1-4.6 2.8-8.3 4.7z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m16.3 94c-0.2 0.1-0.4 0.1-0.5 0.2 1.7 0.1 4.3 0.2 7.7 0.3 1.4 0 2.7 0.1 4 0.1-0.1-1.4-0.3-2.8-0.4-4.1-4.5 1.6-8.3 2.7-10.8 3.5z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m66.9 47.5c3.1-3.3 6.8-7.5 10.8-12.7v-0.1c0.5-0.6 1.4-0.7 2-0.2 1.7 1.5 3.6 2.9 5.6 4.4 1 0.8 2.1 1.5 3.1 2.2 0.3 0.2 0.6 0.3 1 0.3s0.8-0.2 1.2-0.4c0.3-0.3 0.5-0.7 0.5-1.1 0.2-4.9 0.3-9.9 0.3-15v-0.7c0-5.6-0.1-11-0.3-16.3 0-0.2 0-0.3-0.1-0.5-0.3-1.4-1.7-2.3-3.2-2-11.2 2.6-22.3 5.3-33.3 8.3-0.3 0.1-0.6 0.3-0.8 0.5-0.2 0.3-0.3 0.6-0.3 0.9 0 0.5 0.3 1 0.7 1.2 0.9 0.6 1.8 1.1 2.7 1.7 2.2 1.3 4.3 2.5 6.3 3.5 0.7 0.4 1 1.2 0.6 1.9-3.1 6-6.6 11.7-10.6 17.1-8.5 11.4-18 20-30 30.8-6.4 5.7-11.1 9.7-13.7 12.2-0.6 0.6-1.2 1.2-1.7 1.8 0.7-0.1 1.4-0.2 2.1-0.4 1.1-0.3 2.4-0.7 3.6-1.1 2.5-0.9 4.9-1.9 6.1-2.4 9.4-3.8 27.6-12.8 47.4-33.9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m31.5 88.7c-0.6 0.2-1.2 0.5-1.7 0.7 0.2 1.7 0.4 3.5 0.5 5.2h1.9c2.6 0 5 0 7.3-0.1-0.3-3.1-0.4-6.1-0.5-9.2-2.2 1.2-4.8 2.3-7.5 3.4z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m52.9 77.5v0.2c0.1 5.5 0.3 11.1 0.6 16.6 3.4-0.1 6.9-0.2 10.4-0.3-0.3-8.1-0.5-16.3-0.8-24.4-3.3 2.8-6.7 5.4-10.2 7.9z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m91.2 55.3c-0.1-0.1-0.1-0.1-0.2-0.1s-0.2-0.1-0.5-0.2c-0.6-0.3-1.6-0.7-3.5-1.6-1.2-0.6-2.3-1.1-3.4-1.6-0.5-0.2-1-0.4-1.6-0.4-1.1 0-2.1 0.5-2.8 1.4-0.2 0.3-0.4 0.5-0.6 0.8l2.3 40.3h0.6c2.2 0 3.9 0 5.2-0.2 1-0.1 1.9-0.3 2.8-0.7 0.5-0.2 0.9-0.5 1.2-0.9 0.5-0.4 0.8-1 1-1.6 0.2-0.9 0.3-1.8 0.3-2.7 0-1.7-0.1-4.1-0.1-7.5 0-2.1 0.1-4.7 0.3-7.7 0.3-4.9 0.8-8.8 0.8-11.8 0-1.2-0.1-2.4-0.4-3.5-0.4-0.8-0.8-1.5-1.4-2z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "m65.8 67.1c0 0.1 0.1 0.3 0.1 0.4 0.3 8.8 0.6 17.6 0.9 26.4 3.2-0.1 6.4-0.1 9.6-0.1h1.4c0-0.1 0.1-0.2 0.1-0.4-0.7-12.2-1.4-24.5-2.1-36.7-3.1 3.7-6.5 7.1-10 10.4z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m20.6 84.1c9.6-3.9 28.3-13.1 48.4-34.6 2.9-3.1 6.3-7 10.1-11.8 1.4 1.2 3 2.4 4.6 3.6 1.1 0.8 2.1 1.5 3.2 2.3 1.8 1.2 4.1 1.1 5.7-0.4 0.9-0.8 1.4-2 1.5-3.2 0.2-4.9 0.3-9.9 0.3-15.1v-0.7c0-5.6-0.1-11.1-0.3-16.4-0.1-3-2.7-5.4-5.7-5.3-0.3 0-0.7 0.1-1 0.1-11.4 2.6-22.6 5.3-33.7 8.3-1 0.3-1.8 0.8-2.4 1.6-0.5 0.8-0.8 1.7-0.8 2.6 0 1.5 0.8 2.9 2 3.7 0.9 0.6 1.8 1.1 2.8 1.7 1.8 1.1 3.5 2 5.2 2.9-2.8 5.4-6.1 10.6-9.7 15.5-8.2 11.1-17.6 19.5-29.6 30.3-5.2 4.7-9.3 8.2-12.2 10.7-1.2 1-2.3 2.1-3.3 3.3-0.4 0.4-0.7 0.8-1 1.3s-0.5 1-0.5 1.5c0 0.7 0.3 1.3 0.9 1.7 0.3 0.2 0.6 0.4 1 0.4 0.3 0.1 0.6 0.1 1 0.1 1.1 0 2.3-0.2 3.4-0.5 2-0.5 3.9-1.2 5.8-1.9 1.8-0.7 3.4-1.4 4.3-1.7zm-10.9 0.8c-0.7 0.2-1.4 0.3-2.1 0.4 0.5-0.6 1.1-1.2 1.7-1.8 2.7-2.5 7.4-6.5 13.8-12.1 12-10.8 21.6-19.4 30-30.8 4-5.4 7.6-11.1 10.6-17.1 0.4-0.7 0.1-1.6-0.6-1.9-2.1-1.1-4.2-2.3-6.3-3.5-0.9-0.6-1.8-1.1-2.7-1.7-0.4-0.3-0.7-0.7-0.7-1.2 0-0.3 0.1-0.6 0.3-0.9s0.5-0.5 0.8-0.5c11-3.1 22.1-5.8 33.3-8.4 1.4-0.3 2.8 0.6 3.2 2v0.5c0.2 5.2 0.3 10.7 0.3 16.3v0.7c0 5.2-0.1 10.2-0.3 15 0 0.4-0.2 0.9-0.5 1.1-0.3 0.3-0.7 0.4-1.2 0.4-0.3 0-0.7-0.1-1-0.3-1-0.7-2-1.4-3.1-2.2-2-1.5-3.9-3-5.6-4.4-0.6-0.5-1.5-0.4-2 0.2v0.1c-4 5.2-7.7 9.5-10.8 12.7-19.7 21.1-38 30.1-47.4 33.9-1.2 0.5-3.6 1.5-6.1 2.4-1.2 0.4-2.5 0.8-3.6 1.1z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("line", {
  className: "st1",
  x1: 4.5,
  x2: 4.5,
  y1: 87.1,
  y2: 87.1
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m95.7 60.7c0-1.5-0.1-3-0.5-4.4-0.4-1.3-1.2-2.4-2.3-3.3-0.2-0.1-0.4-0.3-0.6-0.4-0.3-0.2-0.6-0.3-1.2-0.6s-1.5-0.7-2.9-1.3c-1.2-0.6-2.3-1.1-3.3-1.6-2.7-1.4-6-0.6-7.9 1.8-7.8 9.9-17 18.4-27.5 25.4-6 3.8-12.4 7.1-19 9.8-5.3 2.2-10 3.6-13.4 4.7-1.7 0.5-3.1 1-4.1 1.4-0.5 0.2-0.9 0.4-1.4 0.7l-0.6 0.6c-0.2 0.3-0.4 0.7-0.4 1.1v0.2c0 0.2 0.1 0.5 0.3 0.7 0.2 0.3 0.5 0.6 0.8 0.7 0.5 0.2 1.1 0.4 1.6 0.5 1.3 0.2 2.5 0.3 3.8 0.4 1.6 0.1 3.7 0.2 6.2 0.2 3.2 0.1 6.2 0.1 8.9 0.1 7 0 12.5-0.2 17.4-0.3 8.9-0.2 17.8-0.6 26.7-0.6h0.3 4.8c2.3 0.1 4.6 0 6.9-0.4 0.8-0.1 1.6-0.4 2.4-0.8 0.7-0.4 1.4-0.8 2-1.4 0.8-0.8 1.4-1.8 1.8-2.9 0.3-1.1 0.4-2.3 0.4-3.5 0-1.9-0.1-4.2-0.1-7.5 0-2.1 0.1-4.6 0.2-7.5 0.2-4.6 0.7-8.5 0.7-11.8zm-72.3 33.8c-3.4-0.1-6-0.2-7.7-0.3 0.2-0.1 0.4-0.1 0.5-0.2 2.5-0.8 6.3-2 10.7-3.6 0.1 1.4 0.3 2.8 0.4 4.1-1.2 0.1-2.5 0.1-3.9 0zm8.8 0.1h-1.9c-0.2-1.7-0.4-3.5-0.5-5.2 0.6-0.2 1.1-0.4 1.7-0.7 2.7-1.1 5.3-2.3 7.5-3.4 0.1 3.1 0.2 6.1 0.5 9.2-2.2 0.1-4.6 0.1-7.3 0.1zm17.4-0.3c-2.3 0-4.7 0.1-7.2 0.2-0.3-3.3-0.5-6.7-0.5-10 0-0.2 0-0.3-0.1-0.5 3.7-1.9 6.6-3.6 8.3-4.7 0.1 5 0.3 10 0.5 15h-1zm3.9-0.1c-0.3-5.5-0.5-11-0.6-16.6v-0.2c3.5-2.4 6.9-5.1 10.2-7.9 0.3 8.1 0.5 16.3 0.8 24.4-3.5 0.1-7 0.2-10.4 0.3zm24.3-0.4h-1.4c-3.2 0-6.4 0.1-9.6 0.1-0.3-8.8-0.6-17.6-0.9-26.4 0-0.1 0-0.3-0.1-0.4 3.6-3.3 6.9-6.8 10.1-10.4 0.7 12.2 1.4 24.5 2.1 36.7-0.1 0.1-0.2 0.2-0.2 0.4zm14.2-21.3c-0.2 3-0.2 5.6-0.2 7.7 0 3.4 0.1 5.8 0.1 7.5 0 0.9-0.1 1.8-0.3 2.7-0.2 0.6-0.5 1.2-1 1.6-0.4 0.4-0.8 0.7-1.2 0.9-0.9 0.4-1.8 0.6-2.8 0.7-1.3 0.1-3 0.2-5.2 0.2h-0.6l-2.3-40.3c0.2-0.3 0.4-0.5 0.6-0.8 0.7-0.9 1.7-1.4 2.8-1.4 0.5 0 1.1 0.1 1.6 0.4 1 0.5 2.1 1.1 3.4 1.6 1.9 0.9 2.9 1.3 3.5 1.6 0.3 0.1 0.4 0.2 0.5 0.2s0.1 0.1 0.2 0.1c0.6 0.5 1.1 1.2 1.3 1.9 0.3 1.1 0.4 2.3 0.4 3.5 0.1 3-0.5 7-0.8 11.9z"
});

var SvgStockSummary = function SvgStockSummary(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    fill: "#FFF",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStockSummary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stock-summary.425159fe.svg";
export { ForwardRef as ReactComponent };